module.exports = __webpack_public_path__ + "img/body-2.81ff4e57.png";